import type { GuestFlowType, GuestMenuListMode } from '../../data/domains/config/appConfig';

export type MainScreenGuestRoute = 'Order' | 'DailyMenuFlow' | 'SubscriptionList';

export type MainScreenMenuRouteDef = {
  route: MainScreenGuestRoute;
  labelKey: 'main.order' | 'main.menu' | 'main.plans';
  requires_online_orders?: boolean;
};

export const MAIN_SCREEN_MENU_ROUTES: MainScreenMenuRouteDef[] = [
  { route: 'Order', labelKey: 'main.order', requires_online_orders: true },
  { route: 'DailyMenuFlow', labelKey: 'main.menu' },
  { route: 'SubscriptionList', labelKey: 'main.plans' },
];

export function resolveGuestRouteParams(
  route: MainScreenGuestRoute,
  guest_flow_type: GuestFlowType,
): Record<string, boolean> {
  if (route === 'SubscriptionList' && (guest_flow_type === 'type2' || guest_flow_type === 'type3')) {
    return { guestExplore: true };
  }
  if (route === 'DailyMenuFlow' || route === 'SubscriptionList' || route === 'Order') {
    return { guestBrowse: true };
  }
  return {};
}

export function filterMainScreenMenuRoutes(
  routes: MainScreenMenuRouteDef[],
  guest_menu_list: GuestMenuListMode,
  show_online_orders: boolean,
): MainScreenMenuRouteDef[] {
  let filtered = routes.filter(route => !route.requires_online_orders || show_online_orders);

  if (guest_menu_list === 'custom') {
    filtered = filtered.filter(route => route.route === 'DailyMenuFlow' || route.route === 'SubscriptionList');
  }

  return filtered;
}

export function shouldShowMainScreenJourney(
  guest_menu_list: GuestMenuListMode,
  is_journey = true,
): boolean {
  return is_journey && (guest_menu_list === 'full' || guest_menu_list === 'random');
}

export function shouldShowMainScreenConsultation(
  guest_menu_list: GuestMenuListMode,
  show_consultations: boolean,
): boolean {
  return show_consultations && shouldShowMainScreenJourney(guest_menu_list);
}
